module.exports = __webpack_public_path__ + "static/media/1005000.160ae7bc.png";